var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Video")]),_c('ui-component',{attrs:{"componentData":_vm.componentData.content.video}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }